import { TRootState }    from 'Redux/Reducers';
import { arrayContains } from 'Utils';
import Actions           from 'Redux/Actions';

export const isEventCategoryLoading = (state: TRootState): boolean =>
  arrayContains(state.eventCategory.openRequests, [
    Actions.findEventCategoryRequest.type,
    Actions.findEventCategoriesRequest.type,
    Actions.createEventCategoryRequest.type,
    Actions.updateEventCategoryRequest.type,
    Actions.deleteEventCategoryRequest.type,
  ]);
